// ------------------------------------
// props 輸入需求 : 
// props.page : component         ( "dash", "history", "connection"... )
// ------------------------------------
    
import React from 'react'
import './waiting.scss'

const WaitingIcon =(props)=>{

    return(
        <div className='w-100 h-100 fx-ccc'>
            <div className={`waitingICON circle rotating ${props.page}`}>
            </div>
        </div>
    );	

}
export default WaitingIcon;